import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { Device } from 'projects/qcloud-models/device/device.model';

@Component({
  selector: 'app-assign-devices',
  templateUrl: './assign-devices.component.html',
  styleUrls: ['./assign-devices.component.css'],
  encapsulation : ViewEncapsulation.None
})
export class AssignDevicesComponent implements OnInit {

  @Input() devices: Device[];
  @Input() deviceMultiCtrl: UntypedFormControl;
  public deviceMultiFilterCtrl: UntypedFormControl = new UntypedFormControl();
  public filteredDevicesMulti: ReplaySubject<Device[]> = new ReplaySubject<Device[]>(1);

  protected _onDestroy = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    // load the initial device list
    this.filteredDevicesMulti.next(this.devices.slice());

    // listen for search field value changes
    this.deviceMultiFilterCtrl.valueChanges
    .pipe(takeUntil(this._onDestroy))
    .subscribe(() => {
      this.filterDevicesMulti();
    });
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredDevicesMulti.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.deviceMultiCtrl.patchValue(val);
        } else {
          this.deviceMultiCtrl.patchValue([]);
        }
      });
  }

  protected filterDevicesMulti() {
    if (!this.devices) {
      return;
    }
    // get the search keyword
    let search = this.deviceMultiFilterCtrl.value;
    if (!search) {
      this.filteredDevicesMulti.next(this.devices.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the Devices
    this.filteredDevicesMulti.next(
      this.devices.filter(device => device.deviceName.toLowerCase().indexOf(search) > -1)
    );
  }

}
